export const colorObj = {
    1: { rise: '#FF6907', fall: '#00a871', zero: 'gray' },
    2: { rise: '#00a871', fall: '#FF6907', zero: 'gray' },
    3: { rise: '#f03a56', fall: '#00a871', zero: 'gray' },
    4: { rise: '#00a871', fall: '#f03a56', zero: 'gray' },
}

export const colorObj_black = {
    1: { rise: '#EB5528', fall: '#13B57A', zero: '#858585' },
    2: { rise: '#13B57A', fall: '#EB5528', zero: '#858585' },
    3: { rise: '#E74442', fall: '#13B57A', zero: '#858585' },
    4: { rise: '#13B57A', fall: '#E74442', zero: '#858585' },
}

export const mktColor = {
    sz: { white: '#FF6476', black: '#EB5567' },
    hk: { white: '#7933D9', black: '#9858F0' },
    us: { white: '#0569FF', black: '#3485FF' },
    sh: { white: '#FF6476', black: '#EB5567' },
    default: { white: '#FF6476', black: '#EB5567' },
}

export const fundMktsTypeMap = {
    mf: 'public',
}

